import React from 'react'
import { connect } from 'react-redux'
import Autosuggest from 'react-autosuggest';
import { change as changeFieldValue } from 'redux-form';
import { findAll } from 'highlight-words-core'
import buscarCidadesPorNome from '../../actions/cidade/buscarCidadesPorParte'

const theme = {
  input: 'form-control form-control-lg campo-busca',
  suggestion: 'list-group-item truncate-dd-a',
  suggestionsList: 'p-0',
  suggestionHighlighted: 'bg-light',
  suggestionFocused: 'active'
};

let time = null;

const classeHighlight = 'font-weight-bold';

const escapeRegexCharacters = str => str.replace(/[.*+?^${}()|[\]\\]/g, '');

const getValorSugestao = sugestao => `${sugestao.nome}-${sugestao.uf}`;

const trataAcentuacao = (value) => {
  let expressao = value;

  const mapaAcentuacao = [
    {
      expressaoProcurar: /a/gi,
      expressaoSubstituir: '[\u0061\u00E1\u00E2\u00E3]'
    },
    {
      expressaoProcurar: /c/gi,
      expressaoSubstituir: '[\u0063\u00E7]'
    },
    {
      expressaoProcurar: /e/gi,
      expressaoSubstituir: '[\u0065\u00E9\u00EA]'
    },
    {
      expressaoProcurar: /i/gi,
      expressaoSubstituir: '[\u0069\u00ED]'
    },
    {
      expressaoProcurar: /o/gi,
      expressaoSubstituir: '[\u006F\u00F3\u00F4\u00F5]'
    },
    {
      expressaoProcurar: /u/gi,
      expressaoSubstituir: '[\u0075\u00FA]'
    },
  ];

  mapaAcentuacao.forEach((i) => {
    expressao = expressao.replace(i.expressaoProcurar, i.expressaoSubstituir)
  });

  return expressao;
}


const getSugestoes = (value, empresas) => {
  let escapedValue = escapeRegexCharacters(value.trim());

  if (escapedValue === '') {
    return [];
  }

  escapedValue = trataAcentuacao(escapedValue);

  const regex = new RegExp(`\\W*(${escapedValue})\\W*`, 'i');

  return empresas.filter(grupo => regex.test(getValorSugestao(grupo)))
};

const montaSugestaoComHighlight = (part, index) => {
  const classe = part.highlight ? classeHighlight : null;

  return (
    <span className={classe} key={index}>{part.text}</span>
  )
};

const exibeSugestao = (sugestao, { query }) => {
  const textoSugestao = `${sugestao.nome}-${sugestao.uf}`;

  const matches = findAll({
    searchWords: [trataAcentuacao(query)],
    textToHighlight: textoSugestao
  });
  const parts = matches.map((parte) => {
    const { end, highlight, start } = parte;
    const text = textoSugestao.substr(start, end - start);
    return {
      text,
      highlight
    }
  });

  return (
    <a
      key={sugestao.id}>{parts.map(montaSugestaoComHighlight)}
    </a>
  )
};

export class SelecaoCidadeAutocompleteRotaConexao extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      value: props.value !== null && props.value !== undefined && props.value.nome && props.value.uf ? `${props.value.nome}-${props.value.uf}` : '',
      sugestoes: []
    };
  }

  componentDidUpdate (_prevProps) {
    if(this.props.value !== _prevProps.value){
      this.setState({value: this.props.value !== null && this.props.value !== undefined && this.props.value.nome && this.props.value.uf
          ? `${this.props.value.nome}-${this.props.value.uf}` : '', sugestoes: []})
    }
  }

  onSuggestionsFetchRequested = ({ value }) => {
    clearTimeout(time);    
    let valor = value.trim().replace(/[^A-zÁ-ú- 0123456789]+/g, '')
    time = setTimeout(() => {
      if (valor.length > 3) {
        this.props.buscarCidadesPorNome(valor)
          .then((resp) => {
            if (resp.payload.data) {
              this.setState({
                sugestoes: getSugestoes(value, resp.payload.data)
              });
            }
          })
      }
    }, 500);
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      sugestoes: []
    });
  };

  onChange = (event, { newValue }) => {
    if (this.props.ehVenda) {
      this.props.limparViagens(this.props.name)
    }

    this.setState({
      value: newValue
    });
  };

  onSuggestionSelected (event, { suggestion }) {
    this.props.selecionarCidade(suggestion);
    this.setState({
      value: `${suggestion.nome}-${suggestion.uf}`
    });
  }

  storeInputReference = (autosuggest) => {
    if (autosuggest) {
      this.input = autosuggest.input;
    }
  };

  focus () {
    this.input.focus()
  }

  render () {
    const { value } = this.state;

    const inputProps = {
      placeholder: this.props.placeholder,
      id: this.props.name,
      value,
      onChange: this.onChange,
      disabled: this.props.disabled
    };

    return (
      <React.Fragment>
        <Autosuggest suggestions={this.state.sugestoes}
                     getSuggestionValue={getValorSugestao}
                     renderSuggestion={exibeSugestao}
                     onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                     onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                     onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                     inputProps={inputProps}
                     theme={theme}
                     ref={this.storeInputReference}/>
        {this.props.exibeLimpar ? <button type="button" className="close ml-3" aria-label="Close" style={{ color: 'red' }}
                                          onClick={() => {
                                            this.props.limpar('');
                                            this.setState({ value: '' })
                                          }
                                          }>
          <i className="material-icons">
            &#xe5cd;
          </i>
        </button> : ''}
      </React.Fragment>


    )
  }
}


export const mapStateToProps = state => (
  {
    itinerarios: state.itinerarios,
    changeFieldValue,
    empresaSelecionada: state.empresaSelecionada,
    cidades: state.cidades,
  });


export default connect(mapStateToProps,
  {
    buscarCidadesPorNome
  })(SelecaoCidadeAutocompleteRotaConexao)
